import { render, staticRenderFns } from "./BatchModifyTitle.vue?vue&type=template&id=b51fd114&scoped=true"
import script from "./BatchModifyTitle.vue?vue&type=script&lang=js"
export * from "./BatchModifyTitle.vue?vue&type=script&lang=js"
import style0 from "./BatchModifyTitle.vue?vue&type=style&index=0&id=b51fd114&prod&scoped=true&lang=css"
import style1 from "./BatchModifyTitle.vue?vue&type=style&index=1&id=b51fd114&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51fd114",
  null
  
)

export default component.exports